var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 50.8 50.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.6 -123.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.04588234,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    cx: 105,
    cy: 148.5,
    r: 25.4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#df5206",
      fillRule: "evenodd",
      strokeWidth: 0.38221318
    },
    d: "m104.66 153.757 15.372-15.371a.97.97 0 0 1 1.367 0 .972.972 0 0 1-.001 1.364l-15.373 15.371a.966.966 0 0 1-1.361.002.972.972 0 0 1-.003-1.366m2.726 2.728 13.002-13a.967.967 0 0 1 1.363 0 .97.97 0 0 1 0 1.363l-13.001 13a.967.967 0 0 1-1.362 0 .97.97 0 0 1-.001-1.363m2.726 2.727 10.366-10.365a.97.97 0 0 1 1.364-.002.972.972 0 0 1-.002 1.366l-10.364 10.364a.968.968 0 0 1-1.364 0 .97.97 0 0 1 0-1.363"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#6a7029",
      fillRule: "evenodd",
      strokeWidth: 0.38221318
    },
    d: "m101.957 152.033-13.799-13.799a.969.969 0 0 1 .002-1.366.97.97 0 0 1 1.362.002l13.8 13.799a.967.967 0 0 1 0 1.362.97.97 0 0 1-1.365.003m2.768-2.687-11.467-11.468a.967.967 0 0 1 0-1.364.97.97 0 0 1 1.363 0l11.467 11.469a.968.968 0 0 1 0 1.363.969.969 0 0 1-1.363 0m2.797-2.657-8.902-8.903a.966.966 0 0 1-.001-1.363.972.972 0 0 1 1.364 0l8.903 8.902a.97.97 0 0 1-.001 1.364.97.97 0 0 1-1.363 0M98.146 152.498v-.003s-.177.19-.416.507c-.008.013-.018.024-.027.036-.512.693-1.307 2.01-1.472 3.736-.246 2.579.834 4.081.834 4.081s-.138-1.524.624-2.444a3.76 3.76 0 0 1 .557-.551 3.747 3.747 0 0 0 2.583 1.037 3.757 3.757 0 0 0 2.884-1.344c.55-.654-4.884-5.75-5.567-5.055"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f2a7ed526878c386102eca55db12262.svg";
export { ForwardRef as ReactComponent };